module.exports = __webpack_public_path__ + "media/recipes/4-09271850.png";